import { render } from "./DependencyRow.vue?vue&type=template&id=5a2b2da9"
import script from "./DependencyRow.vue?vue&type=script&lang=js"
export * from "./DependencyRow.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DependencyRow.vue?vue&type=style&index=0&id=5a2b2da9&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__